// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1aEkh","inputWrap":"Table_inputWrap__1JmE6","col":"Table_col__3HyOC","bmiTooltip":"Table_bmiTooltip__3NJE6"};